<template>
  <div>
    <div class="row" v-if="personality.psiccCode">
      <div class="col-md-6">
        <div class="sheet-panel highs-lows">
          <div class="sheet-header">
            <h3>Personality based career matches</h3>
            <button
              class="info-tip"
              title="Professions below are most likely suited for you based on your personality."
              v-tippy="{ theme: 'navy' }"
            >
              <font-awesome-icon icon="info" />
            </button>
          </div>
          <div class="sheet-content">
            <span
              class="pill-career match"
              v-bind:key="item"
              v-for="item in limitedCareerMatch"
            >
              {{ item }}
            </span>
            <div v-if="limited">
              <hr />
              <button @click="limited = false" class="load-more">
                <font-awesome-icon icon="plus" /> Show more
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="sheet-panel highs-lows">
          <div class="sheet-header">
            <h3>Personality based career mismatches</h3>
            <button
              class="info-tip"
              title="Professions below are less likely suited for you based on your personality."
              v-tippy="{ theme: 'navy' }"
            >
              <font-awesome-icon icon="info" />
            </button>
          </div>
          <div class="sheet-content">
            <span
              class="pill-career mismatch"
              v-bind:key="item"
              v-for="item in limitedCareerMismatch"
            >
              {{ item }}
            </span>
            <div v-if="limited">
              <hr />
              <button @click="limited = false" class="load-more">
                <font-awesome-icon icon="plus" /> Show more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { psiccCode } from "@/assets/psicc.js";
export default {
  computed: {
    limitedCareerMatch() {
      if (this.limited) {
        return this.psiccCode[this.personality.psiccCode].careerMatch.slice(
          0,
          11
        );
      } else {
        return this.psiccCode[this.personality.psiccCode].careerMatch;
      }
    },
    limitedCareerMismatch() {
      if (this.limited) {
        return this.psiccCode[this.personality.psiccCode].careerMismatch.slice(
          0,
          11
        );
      } else {
        return this.psiccCode[this.personality.psiccCode].careerMismatch;
      }
    },
  },
  props: {
    personality: Object
  },
  mounted() {
  },
  data() {
    return {
      limited: true,
      psiccCode: psiccCode
    };
  }
};
</script>
